export const EnvironmentSettings = {
  ApiUrl: process.env.ApiUrl,
};